import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextRotateVerticalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_rotate_vertical"}/>
}
